import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { toast } from 'react-toastify';
import {
    getAuth,
    removeAppRedirection,
    removeAuth,
    removeReferralCode,
    removeReferralEntityType,
    removeIsFdBannerSessionUpdated,
} from '@services/identity.service';
import { logoutUser } from '@services/users.service';
import { reloadAuthenticatedTabs } from '@helpers/miscelleanous';
import { theme } from 'tailwind.config';
import { parseQueryString } from '@helpers/utils';
const Logout = ({
    redirect
}) => {
    const router = useRouter();
    const [redirectPage, queryString] = redirect?.split("?") || [];
    const queryParams = parseQueryString(queryString || '');
    const toastMessage = () => {
        toast.info(
            <p className="font-paragraph text-primary-700 text-sm font-medium">
                Your session has expired, please login again.
            </p>,
            {
                position: 'top-center',
                progress: null,
                style: {
                    '--toastify-color-progress-info': theme?.colors?.primary?.[500], // Replace with your desired progress bar color
                    '--toastify-icon-color-info': theme?.colors?.primary?.[500],
                },
                autoClose: 5000,
            }
        );
    };

    const redirectTo = () => {
        removeAuth();
        removeReferralCode();
        removeReferralEntityType();
        removeAppRedirection();
        removeIsFdBannerSessionUpdated();
        router.replace(redirectPage && (queryParams?.deeplink === 'true' || queryParams?.internalredirect == 'true') ? `/?redirect=${redirectPage}&${queryString}` : '/');
    }

    const logout = async () => {
        const auth = getAuth();
        if (auth) {
            toastMessage();
            reloadAuthenticatedTabs();
        }
        try {
            await logoutUser(getAuth());
            redirectTo();
        } catch (error) {
            console.log(JSON.stringify(error), 'error');
            redirectTo();
        }
    };

    useEffect(() => {
        logout();
    }, []);

    return <></>;
};

export default Logout;

export const getServerSideProps = async (ctx) => {
    // return redirect query from params
    if (ctx.query?.redirect) {
        return {
            props: {
                redirect: ctx.query.redirect,
            },
        };
    }

    return { props: {} };
}
